var map = {
	"./butiker.png": 9131,
	"./bwprofile.jpg": 7321,
	"./erjphow.png": 2953,
	"./erjpmule.png": 8157,
	"./erjpteam.jpeg": 1684,
	"./integrations.png": 5323,
	"./pan_dash.png": 8636,
	"./pan_multitenant.png": 7347,
	"./pan_overview.png": 9409,
	"./pan_projects.png": 1140,
	"./pan_step1.png": 2448,
	"./pan_step2.png": 3475,
	"./pan_team.jpg": 5701,
	"./piechart.png": 8972,
	"./proj_edenred.png": 285,
	"./proj_engager.png": 1998,
	"./proj_paratus.jpeg": 3266,
	"./proj_pelican.jpg": 19,
	"./proj_zipadoo.jpg": 5365,
	"./syncform.png": 4034,
	"./trtbe.png": 4636,
	"./trtss.png": 978,
	"./trtsteps.png": 8317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;